import { Button, Flex, Text, useDisclosure } from "@chakra-ui/react";
import Wallet from "components/Wallet/WalletModal/Wallet";  
import { IconInfo, IconPlus } from "icons";

export const InsufficientFunds = () => {
  const {
    isOpen: isWalletModalOpen,
    onOpen: onWalletModalOpen,
    onClose: onWalletModalClose,
  } = useDisclosure();
  
  return (
    <>
      <Flex
        w="full"
        justifyContent="space-between"
      >
        <Flex
          background="linear-gradient(90deg, rgba(246, 104, 94, 0.2) 0%, rgba(246, 104, 94, 0) 100%)"
          borderLeftRadius="4px"
          w="full"
          alignItems="center"
          gap={2}
          p="2"
        >
          <IconInfo 
            __css={{
              path: {
                fill: 'bloodMoon.100'
              }
            }}
          />
          <Text
            fontSize={{ base: '0.75rem', md: '0.875rem' }}
            lineHeight={{ base: '0.875rem', md: '1.125rem' }}
            fontWeight={500}
            color="bloodMoon.100"
          >
            Not enough funds
          </Text>
        </Flex>

        <Button 
          variant="secondary-gradient" 
          leftIcon={<IconPlus width="14px" height="auto" />}
          onClick={onWalletModalOpen}
          size="sm"
          fontSize="0.875rem"
          px={{ base: 8, md: 6}}
        >
          Add funds
        </Button>
      </Flex>

      <Wallet 
        isOpen={isWalletModalOpen} 
        onClose={onWalletModalClose}
      />
      {/* <TicketCheckoutModal
        isOpen={isTicketModalOpen}
        onClose={onTicketModalClose}
      /> */}
    </>
  )
}